export enum ItemTypes {
  CALENDAR_ITEM = "CALENDAR_ITEM",
  CALENDAR_DAY = "CALENDAR_DAY",
  NONE = "NONE",
}